import { useEffect } from "react";
import { SinglePropertyRentalQuote } from "../quote";
import { observer } from "mobx-react";
import { useOneToolStore } from "../quote/hooks/useOneToolStore";
import { useParams } from 'react-router';

export const EditSingleProperty = observer(() => {
  const { oneToolStore } = useOneToolStore();
  const { singlePropertyRentalQuoteStore } = oneToolStore;
  const { loanId } = useParams<{ loanId: string }>();

  useEffect(() => {
    singlePropertyRentalQuoteStore.loadQuoteToEdit(loanId);
  }, [singlePropertyRentalQuoteStore, loanId]);

  return (<SinglePropertyRentalQuote />);
});